import React from "react";
import PropTypes from "prop-types";

import {
  RelationshipButton,
  RelationshipText,
} from "./FamilyRelationshipPickerSection";
import {
  FnrPopoverWrapper,
  FnrPopoverTriggerButton,
  FnrPopoverOptionsList,
  FnrPopoverOption,
} from "UI/FnrPopover2";

MoreButton.propTypes = {
  moreRelationships: PropTypes.array,
  relationshipTypeID: PropTypes.number,
  changeRelationship: PropTypes.func,
};

export default function MoreButton({
  moreRelationships,
  gender,
  relationshipTypeID,
  selected,
  changeRelationship,
  toggleButtonRef,
  setMoreMenuOpen,
  disabled = false,
}) {
  const onOpen = () => setMoreMenuOpen(true);
  const onClose = () => setMoreMenuOpen(false);

  const foundSelectedRelationship = moreRelationships.find(
    (r) => r.ID === relationshipTypeID
  );

  return (
    <FnrPopoverWrapper>
      <FnrPopoverTriggerButton
        forceRefForMeasurement={toggleButtonRef}
        disabled={disabled}
      >
        <RelationshipButton>
          <RelationshipText>
            {(foundSelectedRelationship && (
              <>
                {gender
                  ? foundSelectedRelationship[gender]
                  : foundSelectedRelationship.name}{" "}
                <div className="far fa-ellipsis-v" />
              </>
            )) ||
              "More"}
          </RelationshipText>
        </RelationshipButton>
      </FnrPopoverTriggerButton>
      <FnrPopoverOptionsList closeOnSelect onOpen={onOpen} onClose={onClose}>
        {moreRelationships.map((r) => (
          <FnrPopoverOption
            key={r.ID}
            selected={r.ID === relationshipTypeID}
            onClick={() => changeRelationship(r.ID)}
          >
            {gender ? r[gender] : r.name}
          </FnrPopoverOption>
        ))}
      </FnrPopoverOptionsList>
    </FnrPopoverWrapper>
  );
}
